import { Link } from "react-router-dom";
import {
  PRODUCT_STATUS,
  formatProductPrice,
  getPrimaryPurchaseLink,
  localize,
} from "../../data/products";

export default function ProductCard({ product, lang, ui }) {
  const purchaseUrl = getPrimaryPurchaseLink(product);
  const isComingSoon = product.status === PRODUCT_STATUS.COMING_SOON;
  const price = formatProductPrice(product);
  const features = localize(product.features, lang) || [];
  const imageAlt = localize(product.images?.alt, lang);

  return (
    <article className="digital-product-card" data-testid={`product-${product.slug}`}>
      <Link className="digital-product-card__image" to={`/productos/${product.slug}`}>
        <img src={product.images.card} alt={imageAlt} loading="lazy" />
        {isComingSoon && (
          <span className="digital-product-card__status">{ui.comingSoon}</span>
        )}
      </Link>

      <div className="digital-product-card__body">
        <div className="digital-product-card__meta">
          <span>{ui.filters[product.category] || product.category}</span>
          <span>{product.language.map((item) => item.toUpperCase()).join(" · ")}</span>
        </div>

        <h3>{localize(product.name, lang)}</h3>
        <p className="digital-product-card__subtitle">
          {localize(product.shortDescription, lang)}
        </p>

        <ul className="digital-product-card__benefits">
          {features.slice(0, 4).map((feature) => (
            <li key={feature}>{feature}</li>
          ))}
        </ul>

        <div className="digital-product-card__footer">
          <div className="digital-product-card__price">
            <small>{isComingSoon ? "" : localize(product.priceLabel, lang) || ui.from}</small>
            <strong>{isComingSoon ? ui.comingSoon : price}</strong>
          </div>

          <div className="digital-product-card__actions">
            <Link className="product-button product-button--secondary" to={`/productos/${product.slug}`}>
              {ui.viewDetails}
            </Link>
            {!isComingSoon && purchaseUrl && (
              <a
                className="product-button product-button--primary"
                href={purchaseUrl}
                target="_blank"
                rel="sponsored noopener noreferrer"
              >
                {ui.buyNow}
              </a>
            )}
          </div>
        </div>
      </div>
    </article>
  );
}
